<template>
  <button type="button" :class="['builderModalClose', { '-onWhite': onWhite }]" aria-label="Закрыть">
    <!-- Тот же крестик, что в модалках DAY-1 (MOB-270); цвет — от кнопки через currentColor -->
    <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
      <path d="M14 12.3502L18.9502 7.40003C19.4057 6.94449 20.1443 6.94449 20.5998 7.40003C21.0554 7.85557 21.0554 8.59415 20.5998 9.0497L15.6496 13.9999L20.5998 18.95C21.0554 19.4056 21.0554 20.1442 20.5998 20.5997C20.1443 21.0552 19.4057 21.0552 18.9502 20.5997L14 15.6495L9.04982 20.5997C8.59427 21.0552 7.85569 21.0552 7.40015 20.5997C6.94461 20.1442 6.94461 19.4056 7.40015 18.95L12.3503 13.9999L7.40015 9.0497C6.94461 8.59415 6.94461 7.85557 7.40015 7.40003C7.85569 6.94449 8.59427 6.94449 9.04982 7.40003L14 12.3502Z" fill="currentColor" />
    </svg>
  </button>
</template>

<script lang="ts" setup>
// Крестик модалки конструктора: на картинке — белый на тёмной подложке, без картинки — серый на светлой.
defineProps({
  onWhite: { type: Boolean, default: false }
})
</script>

<style lang="scss" scoped>
@import './builderModal';

.builderModalClose {
  position: absolute;
  top: $bm-close-offset;
  right: $bm-close-offset;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  width: $bm-close-size;
  height: $bm-close-size;
  padding: 0;
  border: none;
  border-radius: 50%;
  // line-height: 0 — иначе строка шрифта сдвигает svg вниз внутри кнопки
  line-height: 0;
  background: rgba(var(--ac-color-rgb-black), .3);
  color: var(--ac-color-white);
  cursor: pointer;

  &.-onWhite {
    background: var(--ac-color-background);
    color: var(--ac-color-dark-gray);
  }

  svg {
    display: block;
    width: $bm-close-size;
    height: $bm-close-size;
  }
}
</style>
